module.exports = __webpack_public_path__ + "static/media/remove-address.ba3911bd.svg";